import { makeStyles, Theme } from 'styles/utils';

export const useStyles = makeStyles((_theme: Theme) => ({
  viewMode: {
  },
  editMode: {
    '& [class*="MuiCard-root"]': {
      overflow: 'visible',
    },
  }
}));
